import { render } from "./SeguimientoDocumentos.vue?vue&type=template&id=6e3e270d&scoped=true"
import script from "./SeguimientoDocumentos.vue?vue&type=script&lang=js"
export * from "./SeguimientoDocumentos.vue?vue&type=script&lang=js"

import "./SeguimientoDocumentos.vue?vue&type=style&index=0&id=6e3e270d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3e270d"]])

export default __exports__